export default {
  'report.orderNumber': 'Order Number',
  'report.accountId': 'Account ID',
  'report.accountChangeType': 'Account Change Type',
  'report.bonus': 'Bonus',
  'report.withdrawal': 'Withdrawal',
  'report.manualWithdrawal': 'Manual Withdrawal',
  'report.manualDeposit': 'Manual Deposit',
  'report.withdrawalReversal': 'Withdrawal Reversal',
  'report.balanceBeforeChange': 'Balance Before Change',
  'report.changeAmount': 'Change Amount',
  'report.balanceAfterChange': 'Balance After Change',
  'report.changeTime': 'Change Time',
  'report.moneyDetails': 'Money Details',

  'report.date': 'Date',
  'report.totalMembers': 'Total Members',
  'report.registeredUsers': 'Registered Users',
  'report.invitedRegisteredUsers': 'Invited Registered Users',
  'report.trafficInviteUsers': 'Traffic User Invites',
  'report.organicInviteUsers': 'Non-Traffic User Invites',
  'report.restrictedQualifiedInviteUsers': 'Restricted User Qualified Invites',
  'report.unrestrictedQualifiedInviteUsers': 'Unrestricted User Qualified Invites',
  'report.loggedInUsers': 'Online Users',
  'report.oldUserOnlineUsers': 'Existing Online Users',
  'report.trafficUserOnlineUsers': 'Traffic Online Users',
  'report.restrictedUserOnlineUsers': 'Restricted Online Users',
  'report.signedUpUsers': 'Signed Up Users',
  'report.contestants': 'Contestants',
  'report.contestantsNonUnique': 'Contest Entries',
  'report.winners': 'Winners',
  'report.awardAmount': 'Award Amount',
  'report.inviterUsers': 'Inviter Users',
  'report.payoutSubmitUsers': 'Payout Submit Users',
  'report.payoutSuccessUsers': 'Payout Success Users',
  'report.contestD2Users': 'D2 Contestants',
  'report.contestD7Users': 'D7 Contestants',
  'report.promotionCost': 'Promotion Cost',
  'report.promotionCostPlaceholder': 'Empty or integer 0 ~ 999999999',
  'report.operationsReport': 'Operations Report',

  'report.dataDefinition': 'Data Definition',
  // 'report.dataStatisticsDesc1': 'Data will be processed daily at 00:00 Beijing time to statistics data from the previous day',
  'report.dataStatisticsDesc1': 'The data is updated every hour',
  'report.dataStatisticsDesc2': 'All user count data is statistically unique by default',
  'report.termTrafficUser': 'Traffic users',
  'report.termTrafficUserDesc': 'Users referred from tournaments to TOSPORT',
  'report.termRestrictedUser': 'Restricted users',
  'report.termRestrictedUserDesc':
    'Users with at least 2 successful withdrawals and 0 successful deposits on TOSPORT',
  'report.termOnlineRule': 'Online rule',
  'report.termOnlineRuleDesc': 'Logged-in users who opened the site that day',
  'report.termQualifiedInvite': 'Qualified invite',
  'report.termQualifiedInviteDesc':
    'Meets the tournament-entry count configured in the admin and has completed KYC',
  'report.totalMembersDesc': 'Total number of members in the system as of the day',
  'report.registeredUsersDesc': 'Total number of members who registered successfully that day',
  'report.invitedRegisteredUsersDesc':
    "Of that day's registrations, those registered via an invitation code. Invited Registered Users = Traffic User Invites + Non-Traffic User Invites",
  'report.trafficInviteUsersDesc': 'Sub-registrations invited by traffic users',
  'report.organicInviteUsersDesc': 'Sub-registrations invited by non-traffic users',
  'report.restrictedQualifiedInviteUsersDesc':
    'Qualified sub-registrations invited by restricted users',
  'report.unrestrictedQualifiedInviteUsersDesc':
    'Qualified sub-registrations invited by unrestricted users',
  'report.loggedInUsersDesc': 'Includes already logged-in users who visited the site that day',
  'report.oldUserOnlineUsersDesc': 'Online users registered before the day',
  'report.trafficUserOnlineUsersDesc': 'Online users who are traffic users',
  'report.restrictedUserOnlineUsersDesc': 'Online users who are restricted users',
  'report.signedUpUsersDesc': 'Signed up users for the day',
  'report.contestantsDesc': 'Contestants for the day',
  'report.contestantsNonUniqueDesc': 'Includes started contests or leaderboard appearances; counts repeated entries',
  'report.winnersDesc': 'Number of award winners',
  'report.awardAmountDesc': 'Total award amount of winners',
  'report.inviterUsersDesc': 'Inviter users for the day',
  'report.payoutSubmitUsersDesc': 'Payout submit users for the day',
  'report.payoutSuccessUsersDesc': 'Includes manual, automatic, admin payouts and TOSPORT',
  'report.contestD2UsersDesc': 'Contestants on day 2',
  'report.contestD7UsersDesc': 'Contestants on day 7',
  'report.promotionCostDesc': 'Editable any number of times; empty or integer 0 ~ 999999999',
  'report.expand': 'Expand',
  'report.collapse': 'Collapse',

  "report.retained.date": "Date",
  "report.retained.inviteCode": "Invitation Code",
  "report.retained.currency": "Currency",
  "report.retained.registerCount": "Registered Users",
  "report.retained.contestD0": "Participants",
  "report.retained.withdrawCountD0": "Successful Withdrawal Amount/Count",
  "report.retained.contestDay": "Participants",
  "report.retained.retentionRateDay": "Retention Rate",
  "report.retained.withdrawCountDay": "Successful Withdrawal Amount/Count",
  "report.retained.startTimePlaceholder": "Start Date",
  "report.retained.endTimePlaceholder": "End Date",
  "report.retained.export": "Export",
  "report.retained.exportData": "Are you sure you want to export the retention report data under the current filters?",
  "report.retained.confirm": "Confirm",
  "report.retained.cancel": "Cancel",
  "report.retained.export1": "Retention Report",
  "report.retained.nameListExport": "Retention Report Name List Detail",
  "report.retained.day": "Day",
  "report.retained.overallRetentionRate": "Overall Retention Rate",
  "report.retained.overallRetentionRateTip":
    "Total D2 contestants / Total first-time contestants",
  "report.retained.firstContestTotal": "Total First-time Contestants",
  "report.retained.firstContestTotalTip": "Sum of all first-time contestants",
  "report.retained.d2ContestTotal": "Total D2 Contestants",
  "report.retained.d2ContestTotalTip": "Sum of all D2 contestants",

  // Online Users
  "report.online.title": "Online Users",
  "report.online.dateA": "Date A",
  "report.online.dateB": "Date B",
  "report.online.peak": "Peak",
  "report.online.avg": "Avg Online",
  "report.online.trough": "Trough",
  "report.online.dailyTotal": "Daily Total",
  "report.online.trendTitle": "Online Users Trend Comparison",
  "report.online.detailTitle": "Hourly Online Users Detail",
  "report.online.time": "Time",
  "report.online.diff": "Diff",
};
